import { Pickup } from 'site/components/checkout/Shipping/Shipping.tsx'

export function findMinorDistance(pickups: Pickup[]) {
    return pickups.reduce((acc, cur) => {
        if (Object.keys(acc).length === 0) return cur

        const accDistance: number = acc.sla.pickupDistance || 0
        const curDistance = cur.sla.pickupDistance || 0

        if (curDistance < accDistance) return cur

        return acc
    }, {} as Pickup)
}
